import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.471 6.5H5.109a2 2 0 0 0-1.854 1.251L1.2 12.835V5c0-.163.137-.3.3-.3h12c.163 0 .3.137.3.3v.3H15V5c0-.825-.675-1.5-1.5-1.5H11V2A1.5 1.5 0 0 0 9.5.5h-4A1.5 1.5 0 0 0 4 2v1.5H1.5C.675 3.5 0 4.175 0 5l.01 11.16c.042.717.626 1.34 1.413 1.34h11.868c.58 0 1.101-.352 1.318-.889l3.252-8.049a1.5 1.5 0 0 0-1.39-2.062zM5.2 2a.3.3 0 0 1 .3-.3h4a.3.3 0 0 1 .3.3v1.5H5.2V2zm11.549 6.112l-3.252 8.049a.222.222 0 0 1-.206.139H1.423a.213.213 0 0 1-.184-.098.21.21 0 0 1-.022-.207L4.367 8.2a.797.797 0 0 1 .742-.5h11.362a.29.29 0 0 1 .249.132c.04.061.078.158.029.28z" />
  </svg>
);

export default SvgComponent;
